module.exports = __webpack_public_path__ + "img/fi_info.3a54f120.svg";